var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-view"},[_c('h3',[_c('van-icon',{attrs:{"name":_vm.icon}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }